import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import Slider from "react-slick";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";

import SpQuotes from "../../img/decor/sp-quotes.svg";

import Yuriy_Horbunov from "../../img/speaker-quotes/Yuriy_Horbunov.webp";
import Maryna_Avdieieva from "../../img/speaker-quotes/Maryna_Avdieieva.webp";
import Kateryna_Zahorii from "../../img/speaker-quotes/Kateryna_Zahorii.webp";
import Yevhen_Synelnykov from "../../img/speaker-quotes/Yevhen_Synelnykov.webp";
import Olena_Plakhova from "../../img/speaker-quotes/Olena_Plakhova.webp";
import Pavlo_Moroz from "../../img/speaker-quotes/Pavlo_Moroz.webp";
import Andrii_Teliupa from "../../img/speaker-quotes/Andrii_Teliupa.webp";
import Anatoliy_Amelin from "../../img/speaker-quotes/Anatoliy_Amelin.webp";



function Quotes() {
    const sliderRef = React.useRef(null);

    const quotesContent = [
            
            {
                name: "Юрій Горбунов",
                position: "ведучий «1+1» Україна, кінопродюсер ",
                img: Yuriy_Horbunov,
                text: "Кожного разу я зустрічаю і тих самих людей, яким є чим поділитися за час, коли ми не бачилися. І нових, які говорять про свої плани, про те, як вони відбулися, про те, як треба працювати. "
            },
            {
                name: "Марина Авдєєва",
                position: "Co-owner «Арсенал Страхування», Founder Easy Peasy Insurtech",
                img: Maryna_Avdieieva,
                text: "Технології взагалі не повинні замінити людей, вони повинні допомогти людям робити більш креативну роботу і позбавитися нудної. Віддайте AI все, що вам нудно робити самим, і робіть ті речі, на які здатна тільки людина."
            },
            {
                name: "Катерина Загорій",
                position: "директорка ради директорів «Дарниця» та Zagoriy Foundation",
                img: Kateryna_Zahorii,
                text: "Виклики, які зараз стоять перед українським бізнесом, однозначні: зберегти Україну та український бізнес, і зберегти українців.  "
            },
            {
                name: "Євген Синельников",
                position: "український режисер-постановник, телеведучий, ідейний натхненник авторських проєктів з популяризації українського контенту",
                img: Yevhen_Synelnykov,
                text: "«Made in Ukraine» — це вже не просто про підтримку свого. Це про відповідальність: якщо ти ставиш цю позначку, маєш бути впевненим, що твій продукт справді якісний. Зараз хочеться донести, що в Україні робиться багато всього. Ми не те що не пасемо задніх, ми дуже часто попереду."
            },
            {
                name: "Олена Плахова",
                position: "директорка з комунікацій і взаємодії з урядом Kernel",
                img: Olena_Plakhova,
                text: "Раніше бізнеси думали про те, як зробити свій продукт або бренд відомим, зараз усі переходять до нової історії — як зробити свій бренд лавмарком."
            },
            {
                name: "Павло Мороз",
                position: "директор департаменту корпоративної соціальної відповідальності МХП ",
                img: Pavlo_Moroz,
                text: "Не бійтеся заразитися вірусом підприємництва, воно того варте. Не бійтесь грати із сильними суперниками. Граючи із сильними суперниками, ви самі стаєте сильнішими."
            },
            {
                name: "Андрій Телюпа",
                position: "заступник міністра економіки, довкілля та сільського господарства України ",
                img: Andrii_Teliupa,
                text: "Програма «Національний кешбек» продемонструвала позитивні результати: 7,3 млн споживачів активували картки в «Дії», а загальна сума сплачених коштів перевищила 5 млрд грн. Вже 1848 вітчизняних виробників і 382 000 товарів беруть участь у програмі."
            },
            {
                name: "Анатолій Амелін",
                position: "виконавчий директор та співзасновник аналітичного центру «Український інститут майбутнього»",
                img: Anatoliy_Amelin,
                text: "Україні необхідно переглянути державні пріоритети та створити сприятливі умови для того, щоб саме тут було вигідно будувати нові підприємства різних галузей промисловості, зокрема військово-промислового комплексу тощо. "
            },
        ];

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
    };

    return (
        <section className="relative mb-[60px] lg:mb-[120px]">
            <div className="container max-w-full mx-auto px-[clamp(20px,calc(20px+130*((100vw-390px)/1530)),150px)]">


                {/*<div className="flex items-center justify-center gap-4 absolute bottom-0 left-1/2 -translate-x-1/2
                lg:bottom-auto lg:top-1/2 lg:-translate-y-1/2 lg:left-0 lg:translate-x-0 lg:justify-between w-full z-10">
                    <button className="p-3 opacity-40 hover:opacity-100 transition" onClick={() => sliderRef.current?.slickPrev()}>
                        <SlArrowLeft className="text-3xl" />
                    </button>

                    <button className="p-3 opacity-40 hover:opacity-100 transition" onClick={() => sliderRef.current?.slickNext()}>
                        <SlArrowRight className="text-3xl" />
                    </button>
                </div>*/}

                <Slider
                    ref={sliderRef}
                    {...settings}
                    className="[&_.slick-track]:flex [&_.slick-track]:items-start [&_.slick-slide]:h-auto [&_.slick-slide>div]:h-full"
                >
                    {quotesContent.map((item, index) => (
                        <div className="" key={index}>

                            <div className="grid grid-cols-[50%_1fr] gap-x-[20px] md:gap-x-0
                                md:grid-cols-[265px_1fr] xl:md:grid-cols-[405px_1fr]">
                                {/* Фото */}
                                <div className="overflow-hidden rounded-tr-[62px] md:row-span-2 xl:rounded-tr-[150px]"> 
                                   <img src={item.img} alt={item.name} className="h-full object-cover" />
                                </div>
                                <div className="md:pl-8 md:mb-10 md:pt-6 xl:pl-24">
                                    <h3 className="text-xl text-[#00007c] uppercase font-bold leading-[1.2] mb-2 
                                        md:mb-5 xl:text-[32px]">
                                        {item.name}
                                    </h3>

                                    <p className="leading-[1.2] text-xs text-[#00007c] xl:text-lg xl:max-w-[70%]">
                                        {item.position}
                                    </p>
                                </div>
                                <div className="bg-[#babafe] relative  col-span-2 md:col-span-1 pt-[48px] px-4 pb-[40px]
                                    md:pl-8 xl:pl-24 xl:py-[50px]">
                                    
                                    <div className="xl:max-w-[70%] text-base leading-[1.2] xl:text-lg">
                                        {item.text}
                                    </div>

                                    <img src={SpQuotes} className="absolute z-10 -top-[18px] right-6 w-[72px] xl:w-[180px]
                                        xl:-top-[50px]" alt="Quotes" />

                                </div>
                            </div>

                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
}


export default Quotes